(function() {
    'use strict';

    angular
        .module('notification',[]);
})();
